import React, { useEffect, useState } from "react";
import "./style.css";
import PlainEditor from "../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import Image from "../Image/Image.js";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import JsZip from "jszip";
import { Uploader } from "../../../../../../merchant/panel/scripts/body/container/summary/groups/addingGroupWindow/creation/creation.js";
import { partitioned } from "../../../../../sharedScripts/Partitioned.js";
export async function saveAs(data, fileName) {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data);
    a.download = fileName;
    a.classList.add("disable-popup-close");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
export async function saveToZip(zipName, urls, onProgress, onEnd) {
    const zip = new JsZip();
    const folder = zip.folder("zdjęcia");
    let i = 0;
    for (const batch of partitioned(urls, 6)) {
        const tasks = batch.map(async (file) => {
            let uploadResult = await Uploader.useResultRetries(async () => {
                const result = await fetch(file.url, { cache: "default" });
                if (result.status === 200) {
                    onProgress(i++, urls.length);
                    return result.blob();
                }
                return false;
            });
            if (uploadResult === false)
                throw new Error("Failed to download file");
            const name = file.name;
            folder.file(name, uploadResult);
        });
        await Promise.all(tasks);
    }
    zip
        .generateAsync({ type: "blob", streamFiles: true })
        .then((blob) => saveAs(blob, zipName))
        .then(() => {
        onEnd();
    })
        .catch((e) => console.log(e));
}
export default function ImageGallery(props) {
    const [update, setUpdate] = useState(0);
    const [isDownloading, setDownloading] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);
    useEffect(() => {
        setUpdate((o) => o + 1);
    }, [props.clientMessage]);
    useEffect(() => {
        if (isDownloading === false)
            return;
        saveToZip("fotografie.zip", props.withDownloadManyButton.map((name) => ({
            name,
            url: `/api/public/collectionClient/collection/image/${name}/class/full`,
        })), (curr, max) => setDownloadProgress(curr / max), () => {
            setDownloadProgress(0);
            setDownloading(false);
        });
    }, [isDownloading]);
    return (React.createElement("div", { className: "gallery-container" },
        props.clientMessage && (React.createElement(PlainEditor, { editable: false, label: "", onChange: () => { }, example: props.clientMessage, update: update })),
        props.withDownloadManyButton !== undefined && (React.createElement("div", { className: "download-files-info-container" },
            "Mo\u017Cesz te\u017C pobra\u0107 wszystkie zdj\u0119cia naraz (",
            props.withDownloadManyButton.length,
            " szt)",
            React.createElement("br", null),
            React.createElement(Button, { text: "Pobierz wszystko", version: "alternative", onClick: () => {
                    setDownloading(true);
                } }))),
        React.createElement("div", { className: "image-gallery-container" }, props.allowedImages &&
            props.allowedImages.map((image, index) => (React.createElement(Image, { key: index, ...image })))),
        isDownloading && (React.createElement("div", { className: "downloading-menu-container" },
            React.createElement("div", { className: "downloading-menu" },
                "Trwa przygotowywanie zdj\u0119\u0107...",
                React.createElement("br", null),
                Math.round(downloadProgress * 100),
                " %")))));
}
